import React from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import * as R from 'ramda';
import {Maybe} from 'monet';

const escapeSelector = R.replace(/([:.[\]])/g, '\\$1');
const normalizeTarget = R.ifElse(R.is(String), escapeSelector, R.identity);

const toolTip = target => msg => (
  <UncontrolledTooltip
    target={normalizeTarget(target)}
    placement='bottom'
    autohide={false}
    offset='0, 1'
    container='root'
    className='tooltip form-error-tips'
  >
    {msg}
  </UncontrolledTooltip>
);

const ErrorTooltip = ({errors, target}) =>
  Maybe.fromFalsy(errors)
    .map(R.join(', '))
    .map(toolTip(target))
    .orNull();

export default ErrorTooltip;
